"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDeviceDetect = require("react-device-detect");

var _classnames = _interopRequireDefault(require("classnames"));

var _debounce = _interopRequireDefault(require("./utils/debounce"));

var _scroll_ended = _interopRequireDefault(require("./utils/scroll_ended"));

var _icon = _interopRequireDefault(require("./icon"));

var _key_press_options_handler = _interopRequireDefault(require("./utils/key_press_options_handler"));

var _options_list = _interopRequireDefault(require("./shared/options_list"));

var _text_box = _interopRequireDefault(require("./text_box"));

require("../css/select_content.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SelectContent =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectContent, _Component);

  function SelectContent(props) {
    var _this;

    _classCallCheck(this, SelectContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectContent).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function (event) {
      var _this$props = _this.props,
          onScrollEnd = _this$props.onScrollEnd,
          scrollEndOffset = _this$props.scrollEndOffset;

      if (onScrollEnd && (0, _scroll_ended.default)(event.target, scrollEndOffset)) {
        onScrollEnd();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearch", function (value) {
      _this.setState({
        searchedValue: value,
        searchTyping: true
      }, function () {
        _this.delayedCallback(value);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      var searchTyping = _this.state.searchTyping;

      if (_this.highlightedOptionNode) {
        _this.highlightedOptionNode.focus();
      }

      if (searchTyping && _this.searchNode) {
        _this.searchNode.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (event, option) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          options = _this$props2.options;
      var highlightedIndex = _this.state.highlightedIndex;

      switch (event.keyCode) {
        case 13:
          // ENTER
          event.stopPropagation();
          event.preventDefault();

          _this.handleMouseDown(event, option, true);

          break;

        case 27:
          // ESC
          onChange(undefined, true);
          break;

        case 32:
          // SPACE
          event.stopPropagation();
          event.preventDefault();

          _this.handleMouseDown(event, option);

          break;

        case 38:
          // UP
          event.preventDefault();

          if (highlightedIndex > 0) {
            _this.nextOptionSelection(38);
          }

          break;

        case 40:
          // DOWN
          event.preventDefault();

          if (highlightedIndex < options.length - 1) {
            _this.nextOptionSelection(40);
          }

          if (highlightedIndex === options.length - 1) {
            _this.setState({
              keyPressed: true,
              searchTyping: false
            });
          }

          break;

        default:
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyPress", function (e) {
      var searchTyping = _this.state.searchTyping;
      e.persist();

      if (searchTyping) {
        _this.setState({
          keyPressed: true,
          searchTyping: false
        }, function () {
          _this.keyPressOptionsHandler.handle(e.key);
        });
      } else {
        _this.setState({
          keyPressed: true
        }, function () {
          _this.keyPressOptionsHandler.handle(e.key);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDownSearch", function (event) {
      var options = _this.props.options;
      var highlightedIndex = _this.state.highlightedIndex;
      var option = options[highlightedIndex];

      switch (event.keyCode) {
        case 13:
          // ENTER
          event.stopPropagation();
          event.preventDefault();

          _this.handleMouseDown(event, option, true);

          break;

        case 32:
          // SPACE
          break;

        default:
          _this.handleKeyDown(event);

      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseDown", function (e, option) {
      var forceClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      if (option.disabled) {
        return;
      }

      var _this$props3 = _this.props,
          multiple = _this$props3.multiple,
          onChange = _this$props3.onChange,
          options = _this$props3.options;
      var close = forceClose || !multiple;
      var index = options.findIndex(function (opt) {
        return opt.value === option.value;
      });

      _this.setState({
        highlightedIndex: index,
        searchTyping: false
      }, function () {
        onChange(option, close);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseMove", function (e, option) {
      var options = _this.props.options;
      var _this$state = _this.state,
          highlightedIndex = _this$state.highlightedIndex,
          keyPressed = _this$state.keyPressed;

      if (option.disabled || _reactDeviceDetect.isMobile) {
        return;
      }

      e.preventDefault();
      var index = options.findIndex(function (opt) {
        return opt.value === option.value;
      });

      if (keyPressed) {
        _this.setState({
          keyPressed: false
        });
      } else if (index !== highlightedIndex) {
        _this.setState({
          highlightedIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyPressOptionsHandlerCallback", function (highlightedIndex) {
      if (highlightedIndex >= 0) {
        _this.setState({
          highlightedIndex: highlightedIndex
        }, _this.handleFocus);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nextOptionSelection", function (keyCode) {
      var options = _this.props.options;
      var highlightedIndex = _this.state.highlightedIndex;
      var nextIndex = highlightedIndex;
      nextIndex = keyCode === 40 ? nextIndex + 1 : nextIndex - 1;

      while (nextIndex >= 0 && nextIndex <= options.length - 1) {
        if (options[nextIndex].disabled === true) {
          nextIndex = keyCode === 40 ? nextIndex + 1 : nextIndex - 1;
        } else {
          break;
        }
      }

      _this.setState({
        highlightedIndex: nextIndex,
        keyPressed: true,
        searchTyping: false
      }, _this.handleFocus);
    });

    var _highlightedIndex = props.highlightedIndex,
        onSearch = props.onSearch,
        _options = props.options,
        searchDelay = props.searchDelay,
        showSearch = props.showSearch;
    _this.keyPressOptionsHandler = new _key_press_options_handler.default(_options, _this.keyPressOptionsHandlerCallback, 500);
    _this.delayedCallback = (0, _debounce.default)(function (searchedValue) {
      if (onSearch) {
        onSearch(searchedValue);
      }
    }, searchDelay);
    _this.state = {
      highlightedIndex: _highlightedIndex,
      keyPressed: false,
      searchedValue: '',
      searchTyping: showSearch
    };
    return _this;
  }

  _createClass(SelectContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocus();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var options = this.props.options;
      var value = nextProps.value;
      this.keyPressOptionsHandler = new _key_press_options_handler.default(options, this.keyPressOptionsHandlerCallback, 500);

      if (options !== nextProps.options) {
        var lastSelectedValue = value[value.length - 1];
        var index = nextProps.options.findIndex(function (opt) {
          return opt.value === lastSelectedValue;
        });
        this.setState({
          highlightedIndex: index >= 0 ? index : 0
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.delayedCallback.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          multiple = _this$props4.multiple,
          noResults = _this$props4.noResults,
          options = _this$props4.options,
          optionsOrientation = _this$props4.optionsOrientation,
          searchPlaceholder = _this$props4.searchPlaceholder,
          showSearch = _this$props4.showSearch,
          value = _this$props4.value,
          visibleOptions = _this$props4.visibleOptions;
      var _this$state2 = this.state,
          highlightedIndex = _this$state2.highlightedIndex,
          searchedValue = _this$state2.searchedValue;
      var isUpwards = optionsOrientation.includes('up');
      var searchInputClasses = {
        'vn-select-content__search-input': true,
        'vn-select-content__search--downwards': !isUpwards,
        'vn-select-content__search--upwards': isUpwards
      };

      var searchDiv = _react.default.createElement("div", {
        className: "vn-select-content__search"
      }, _react.default.createElement(_text_box.default, {
        className: (0, _classnames.default)(searchInputClasses),
        name: "search",
        onChange: this.handleSearch,
        onKeyDown: this.handleKeyDownSearch,
        placeholder: searchPlaceholder,
        inputRef: function inputRef(search) {
          _this2.searchNode = search;
        },
        type: "text",
        value: searchedValue
      }), _react.default.createElement(_icon.default, {
        name: "search",
        className: "vn-select-content__search-icon"
      }));

      var contentClasses = {
        'vn-select-content': true,
        'vn-select-content--left': optionsOrientation.includes('left'),
        'vn-select-content--downwards': !isUpwards,
        'vn-select-content--upwards': isUpwards
      };
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(contentClasses)
      }, showSearch && !isUpwards && searchDiv, options.length > 0 && _react.default.createElement(_options_list.default, {
        highlightedIndex: highlightedIndex,
        highlightedRef: function highlightedRef(el) {
          _this2.highlightedOptionNode = el;
        },
        multiple: multiple,
        onKeyDown: this.handleKeyDown,
        onKeyPress: this.handleKeyPress,
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onScroll: this.handleScroll,
        options: options,
        value: value,
        visibleOptions: visibleOptions
      }), showSearch && options.length === 0 && _react.default.createElement("div", {
        className: "vn-select-content__no-results"
      }, noResults), showSearch && isUpwards && searchDiv);
    }
  }]);

  return SelectContent;
}(_react.Component);

SelectContent.propTypes = {
  highlightedIndex: _propTypes.default.number,
  multiple: _propTypes.default.bool,
  noResults: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onSearch: _propTypes.default.func,
  onScrollEnd: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    disabled: _propTypes.default.bool,
    icon: _propTypes.default.string,
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
  })).isRequired,
  optionsOrientation: _propTypes.default.arrayOf(_propTypes.default.string),
  scrollEndOffset: _propTypes.default.number,
  searchDelay: _propTypes.default.number,
  searchPlaceholder: _propTypes.default.string,
  showSearch: _propTypes.default.bool,
  value: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])),
  visibleOptions: _propTypes.default.number
};
SelectContent.defaultProps = {
  highlightedIndex: undefined,
  multiple: false,
  noResults: '',
  onChange: function onChange() {},
  onSearch: function onSearch() {},
  onScrollEnd: undefined,
  optionsOrientation: [],
  scrollEndOffset: 0,
  searchDelay: undefined,
  searchPlaceholder: '',
  showSearch: false,
  value: [],
  visibleOptions: 10
};
var _default = SelectContent;
exports.default = _default;